import React from "react";
import {
  Bar,
  BarChart,
  CartesianGrid,
  LabelList,
  ResponsiveContainer,
  XAxis,
} from "recharts";
import { amountFormat } from "../../utils";

// Custom label component to display the value in black
const renderCustomizedLabel = (props) => {
  const { x, y, width, height, value, index, dataKey, data } = props;
  const barCenterX = x + width / 2;
  const labelY = y + height / 2 + 6; // Adjust vertical position
  const isLastBar = index === data?.returnOverview?.length - 1; // Check if it's the last bar
  const isCalculatedBar = dataKey === "calculated"; // Check if it's the "calculated" bar

    // Calculate percentage difference
    const futureSum = data.returnOverview[index].calculated || 0;
    const currentSum = data.returnOverview[0].calculated || 0;
    const percentageDiff = futureSum && currentSum 
      ? Math.round((futureSum / currentSum) * 100)
      : 0;
  return (
    <>
      {/* 503-5526820 */}
      {value && (
        <>
          <text
            x={barCenterX}
            y={labelY}
            fill="black"
            textAnchor="middle"
            dominantBaseline="middle"
            fontSize={10}
            fontWeight="bold"
          >
            ₹{amountFormat(value)}
          </text>
          {isLastBar && isCalculatedBar && data.tradData?.agreeToPayTerm > 0 &&(  // Only show on last calculated bar
            <text 
              x={barCenterX} 
              y={labelY + 15}  // Position above the value
              fill="black"    // Match bar color
              textAnchor="middle"
              fontWeight="bold"
              fontSize={10}
            >
              You will get {percentageDiff}% more
            </text>
          )}
        </>
      )}
    </>
  );
};

const renderCustomizedLabel2 = (props) => {
  const { x, y, width, height, value } = props;
  const barCenterX = x + width / 2;

  // Determine label position based on bar height
  const isTallBar = height > 40; // Threshold for "tall" bars (adjust as needed)
  const labelY = isTallBar
    ? y + height / 2 + 6 // Center for tall bars
    : y - 20; // Top for small bars (with some padding)

  return (
    <>
      {value && (
        <text
          x={barCenterX}
          y={labelY}
          fill="black"
          textAnchor="middle"
          dominantBaseline={isTallBar ? "middle" : "auto"}
          fontSize={10}
          fontWeight="bold"
        >
          ₹{amountFormat(value)}
        </text>
      )}
    </>
  );
};

export default function EnforcedLineChartTrad({ data }) {
  return (
    <div style={{ display: "flex", gap: "20px", width: "100%" }}>
      {/* Chart 1 */}
      <div style={{ width: "30%" }}>
        {" "}
        <ResponsiveContainer height={400}>
          <BarChart
            data={data.returnOverview}
            margin={{
              top: 20,
              right: 30,
              left: 20,
              bottom: 5,
            }}
            barSize={60}
            barCategoryGap={30}
          >
            <XAxis dataKey={"title"} fontSize={10} interval={0} />
            {/* <YAxis /> */}
            <CartesianGrid strokeDasharray="3 3" />

            {/* <Tooltip /> */}
            {/* <Legend /> */}
            <Bar dataKey="surrender" stackId="a"      
            fill="#ff8080"
            

            >
               <LabelList
                dataKey="surrender"
                content={(props) =>
                  renderCustomizedLabel({ ...props, data: data, dataKey: "surrender" })
                }
              />
              </Bar>
            <Bar dataKey="current" stackId="a"      
            fill="#6de6e8"
            >
              <LabelList
                dataKey="current"
                content={(props) =>
                  renderCustomizedLabel({ ...props, data: data, dataKey: "current" })
                }
              />
            </Bar>

            <Bar dataKey="calculated" stackId="a" fill="#40b8d5">
              <LabelList
                dataKey="calculated"
                content={(props) =>
                  renderCustomizedLabel({
                    ...props,
                    data: data,
                    dataKey: "calculated",
                  })
                }
              />
            </Bar>

          </BarChart>
        </ResponsiveContainer>
      </div>
      <div
        className="d-flex flex flex-column align-items-center"
        style={{ width: "70%" }}
      >
        <ResponsiveContainer height={400}>
          <BarChart
            data={data.returnCalculation}
            margin={{
              top: 20,
              right: 30,
              left: 20,
              bottom: 5,
            }}
            barSize={100}
            barCategoryGap={30}
          >
            <XAxis dataKey={"policyYear"} />
            {/* <YAxis /> */}
            <CartesianGrid strokeDasharray="3 3" />

            {/* <Tooltip /> */}
            {/* <Legend /> */}
            <Bar dataKey="currentMaturityPayout" stackId="a" fill="#6de6e8">
              <LabelList
                dataKey="currentMaturityPayout"
                content={renderCustomizedLabel2}
              />
            </Bar>
            <Bar dataKey="calculatedMaturityPayout" stackId="a" fill="#40b8d5">
              <LabelList
                dataKey="calculatedMaturityPayout"
                content={renderCustomizedLabel2}
              />
            </Bar>
          </BarChart>
          {/* "ds" */}
        </ResponsiveContainer>
        <b>How you get your return back?</b>
      </div>
    </div>
  );
}
